'use client';
import { useCallback } from 'react';
import { usePageDirtyStore } from '../store/page-dirty-store';
import DiscardUnsavedContentDialog from './DiscardUnsavedContentDialog';
import { useRouter } from 'next/navigation';

export default function DiscardUnsavedContentDialogContainer() {
  const router = useRouter();
  const confirmationHref = usePageDirtyStore((state) => state.confirmationHref);
  const setShowConfirmationWithHref = usePageDirtyStore(
    (state) => state.setShowConfirmationWithHref
  );

  const onClose = useCallback(() => {
    if (confirmationHref && confirmationHref.length > 0) {
      router.replace(confirmationHref);
    }
  }, [confirmationHref, router]);

  const onOpenChange = useCallback(
    (value: boolean) => {
      if (!value) {
        setShowConfirmationWithHref(null);
      }
    },
    [setShowConfirmationWithHref]
  );

  if (!setShowConfirmationWithHref) {
    return null;
  }

  if (!confirmationHref) {
    return null;
  }

  return (
    <DiscardUnsavedContentDialog
      open={confirmationHref != null}
      onOpenChange={onOpenChange}
      onDiscard={onClose}
    />
  );
}
